module.exports = __webpack_public_path__ + "static/media/twitter.c5ce43f7.svg";